module.exports = __webpack_public_path__ + "static/media/MealDetailsGrey.243a5c4c.svg";